import Defaults from '~/scripts/constants/defaults';

export default class OoAdminCardReadController {
	constructor() {
		this.card_from = undefined;
		this.card_to = undefined;

		/** @type {{ card_from: string; card_to: string; } | undefined} */
		this.link = undefined;
	}

	$doCheck() {
		this.updateName();
	}

	updateName() {
		this.card_from = this.link?.card_from === undefined
			? undefined
			: (Number.parseInt(this.link.card_from, 10) === Defaults.KCARDN ? 'N' : this.link.card_from);

		this.card_to = this.link?.card_to === undefined
			? undefined
			: (Number.parseInt(this.link.card_to, 10) === Defaults.KCARDN ? 'N' : this.link.card_to);
	}
}
